const menuLabelMap = {
  // Content / Info Pages
  "AboutUsPage": "About Us",
  "AdminRegistrationPage": "Admin Registration",
  "AmenitiesPage": "Amenities",
  "AmenitiesListPage": "Amenities List",

  // Landing & Auth Pages
  "Login": "Login",
  "Registration": "Register",
  "EmailConfirmation": "Confirm Email",
  "ResendConfirmationPage": "Resend Confirmation",
  "EmailConfirmationPendingPage": "Email Confirmation Pending",
  // Dashboard & Settings
  "Dashboard": "Dashboard",
  "AdminDashboard": "Admin Dashboard",
  "AccountSettingsPage": "Account Settings",

  "SupportAdminPage": "Support Admin",

  // Hotel & Booking Pages
  "Hotel": "Hotel",
  "HotelDashboardCards": "Hotel Dashboard Cards",
  "HotelEditModal": "Edit Hotel",
  "HotelForm": "Hotel Form",
  "HotelFormStep1A": "Hotel Form Step 1A",
  "HotelFormStep1AA": "Hotel Form Step 1AA",
  "HotelFormStep1B": "Hotel Form Step 1B",
  "HotelFormStep2": "Hotel Form Step 2",
  "HotelFormStep3": "Hotel Form Step 3",
  "HotelFormStep5Registration": "Hotel Registration",
  "HotelList": "Hotel List",
  "HotelProfile": "Hotel Profile",
  "HotelProfileHeader": "Hotel Profile Header",
  "HotelProfilePage": "Hotel Profile",
  "Hotels": "Hotels",
  "BookingListPage": "Booking List",
  "BookingModal": "Booking Modal",
  "BookingPage": "Booking",
  "BookingTypesPage": "Booking Types",
  "Breadcrumb": "Breadcrumb",
  "Calendar": "Calendar",
  "ChangeUserRoleModal": "Change User Role",
  "ChatSidebar": "Chat Sidebar",
  "ChatWindow": "Chat Window",
  "CheckInOutPage": "Check In/Out",
  "ChecklistModal": "Checklist",
  "CheckOut": "Check Out",
  "CompleteUserProfile": "Complete Profile",
  "ContactUsPage": "Contact Us",
  "countries": "Countries",
  "CreateTaskModal": "Create Task",
  "DeleteConfirmationModal": "Delete Confirmation",
  "EditableField": "Editable Field",
  "EditBookingModal": "Edit Booking",
  "EditGuestBillModal": "Edit Guest Bill",
  "EditGuestModal": "Edit Guest",
  "EditOrderModal": "Edit Order",
  "EditRoomModal": "Edit Room",
  "EditUserModal": "Edit User",
  "EstablishmentSetupPage": "Establishment Setup",
  "EventsList": "Events List",
  "EventsListPage": "Events List",
  "EventsPage": "Events",
  "FacilitiesPage": "Facilities",
  "FeaturesPage": "Features",
  "FinancialReportsPage": "Financial Reports",
  "FloorPlansPage": "Floor Plans",
  "ForgotPassword": "Forgot Password",
  "friendlyModuleNames": "Friendly Module Names",
  "GuestBillingPage": "Guest Billing",
  "GuestListPage": "Guest List",
  "GuestProfilesPage": "Guest Profiles",
  "HousekeeperDashboard": "Housekeeper Dashboard",
  "HousekeepingDashboard": "Housekeeping Dashboard",
  "HousekeepingModal": "Housekeeping Modal",
  "HousekeepingPage": "Housekeeping",
  "HousekeepingReportsPage": "Housekeeping Reports",
  "KycApprovalPage": "KYC Approval",
  "KycApprove": "KYC Approve",
  "KycReject": "KYC Reject",
  "KYCRejectionPage": "KYC Rejection",
  "KYCUploadPage": "KYC Upload",
  "KYCVerificationPage": "KYC Verification",
  "LandingPage": "Home", // Duplicate; ensure one entry remains.
  "MaintenanceDashboard": "Maintenance Dashboard",
  "MaintenancePage": "Maintenance Task",
  "MaintenanceRequestForm": "Request Maintenance",
  "ManageStaffPage": "Manage Staff",
  "MinimalBookingForm": "Minimal Booking Form",
  "Modal": "Modal",
  "NotFound": "Not Found",
  "PricingPage": "Pricing",
  "ProfileSettings": "Profile Settings",
  "ProfileSettingsPage": "Profile Settings",
  "ProgressBar": "Progress Bar",
  "PromotionsPage": "Promotions",
  "RatesPage": "Rates",
  "RejectKyc": "Reject KYC",
  "ReportsPage": "Reports",
  "RequestResetPassword": "Request Reset Password",
  "RequestServiceModal": "Request Service",
  "ReservatioModal": "Reservatio Modal",
  "ReservationCalendar": "Reservation Calendar",
  "ReservationCalendarPage": "Reservation Calendar",
  "ReservationGantt": "Reservation Gantt",
  "ReservationGanttWrapper": "Reservation Gantt Wrapper",
  "ReservationReportsPage": "Reservation Reports",
  "ResetPassword": "Reset Password",
  "RoleCreationModal": "Role Creation",
  "RoomBookingCalendar": "Room Booking Calendar",
  "RoomDropdwn": "Room Dropdown",
  "RoomImagesPage": "Room Images",
  "RoomListPage": "Room List",
  "RoomMaintenancePage": "Room Maintenance",
  "RoomPricePage": "Room Price",
  "RoomQRPage": "Room QR",
  "RoomServiceRequestsPage": "Room Service Requests",
  "RoomStatusPage": "Room Status",
  "RoomTypesPage": "Room Types",
  "SearchGuestPage": "Search Guest",

  // Additional / Utility Pages
  "Settings": "Settings", // duplicate, ensure one entry.
  "SettingsPage": "Settings Page", // duplicate
  "SetupHotel": "Setup Hotel",
  "SetupHotelPage": "Setup Hotel",
  "Spinner": "Spinner",
  "Staff": "Staff",
  "StaffList": "Staff List",
  "TasksPage": "Tasks",
  "tesmp": "Tesmp",
  "Unauthorized": "Unauthorized",
  "UserDashboard": "User Dashboard",
  "UsersPage": "Users",

  // System Admin (Extra) Modules
  "ManageUsers": "Manage Users", // duplicate, keep one instance.
  "ModuleAssignment": "Module Assignment", // duplicate
  "KycReviewPage": "KYC Review",
  
  // New Modules
  "RestaurantOrderPage": "Restaurant Orders",
  "CreateServicePage": "Create Service",
  "SystemLogPage": "System Logs",
 "CssEditorPage": "CSS Editor",
"PermissionManager": "Permissions Manager",
 "AdminLegalDocsPage": "Legal Documents",
  "HotelAffiliationManagementPage": "Affiliations",
"HotelAgentApplicationsPage": "Agent Applications",
  "HotelAgentKycPage": "KYC Verification",
  "HotelAgentCommissionsPage": "Commission Control",
  "AllAgentsKycPage": "All Agents KYC",  // Admin page for reviewing all registered agents and their KYC status
  "HotelSlaPage": "SLA Management",  // <-- ADD THIS LINE

};

export default menuLabelMap;
